var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1711074368948,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4288,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M889.00148 1024H135.00148C60.60148 1024 0.00148 963.4 0.00148 889V752c0-24.9 20.1-45 45-45s45 20.1 45 45v137c0 24.8 20.2 45 45 45h754c24.8 0 45-20.2 45-45V135c0-24.8-20.2-45-45-45H135.00148c-24.8 0-45 20.2-45 45v137c0 24.9-20.1 45-45 45S0.00148 296.9 0.00148 272V135C0.00148 60.6 60.60148 0 135.00148 0h754c74.4 0 135 60.6 135 135v754c0 74.4-60.6 135-135 135z",
    "p-id": 4289,
    fill: "#bfbfbf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.00148 558c-24.7 0-44.8-20-45-44.7-0.2-24.9 19.9-45.1 44.7-45.3l518.9-3.3-130.7-130.6c-17.6-17.6-17.6-46.1 0-63.6 17.6-17.6 46.1-17.6 63.6 0l206.8 206.8c12.8 12.8 16.7 32.1 9.8 48.9s-23.2 27.8-41.3 27.9l-626.5 4c-0.1-0.1-0.2-0.1-0.3-0.1z",
    "p-id": 4290,
    fill: "#bfbfbf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M464.80148 764.8c-11.5 0-23-4.4-31.8-13.2-17.6-17.6-17.6-46.1 0-63.6l206.9-207c17.6-17.6 46.1-17.6 63.6 0 17.6 17.6 17.6 46.1 0 63.6l-206.9 207c-8.8 8.8-20.3 13.2-31.8 13.2z",
    "p-id": 4291,
    fill: "#bfbfbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.04606770a0859c14c89068057c1be895.svg";
export { ForwardRef as ReactComponent };